import { Link } from 'react-router-dom';

interface TagProps {
  children: string;
  to?: string;
}

export default function Tag({ children, to }: TagProps) {
  const base =
    'inline-flex items-center rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900 whitespace-nowrap';

  if (to) {
    return (
      <Link to={to} className={`${base} transition-colors hover:bg-secondary-200`}>
        {children}
      </Link>
    );
  }

  return <span className={base}>{children}</span>;
}